<script>

    import { toast } from 'bulma-toast'
    import { modalStore, notifyStore } from '../stores'

    import PricingsService from '../$services/pricings.service.js'
    import Switch from '../$components/switch.svelte'
    import File from '../$components/file.svelte'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'

    import ButtonSave from '../$components/button.save.svelte'

    let data = {}
    let loading = false

    async function uploadPricings() {

        loading = true
        const resp = await PricingsService.uploadPricings(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: `${resp.data.length} Precios guardados`, type: 'is-success'})
        notifyStore.set('pricings_updated')

        modalStore.close()
    }

</script>

<Form on:submit={uploadPricings} { loading } >

    <File bind:file={data.file} />
    <br>

    <div class="is-flex is-justify-content-space-between is-align-items-center">
        <a href="/files/pricing_template.csv" download="pricing_template.csv">Descargar plantilla</a>
        <ButtonSave { loading } />
    </div>

</Form>